import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function WhatsIncludedSection() {
  const items = ['Enclosed system housing', 'Plug-and-play electric pump', '75-foot hose', 'Adjustable trigger jet spray wand', 'External siphon intake line'];
  return <section className="py-16 bg-white" data-id="element-812">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-813">
        <h2 className="text-3xl font-bold text-brand-dark mb-8" data-id="element-814">
          What's Included
        </h2>
        <div className="bg-brand-light p-8 rounded-xl border border-gray-200" data-id="element-815">
          <ul className="space-y-4" data-id="element-816">
            {items.map((item, index) => <li key={index} className="flex items-start" data-id="element-817">
                <CheckCircle2 className="h-6 w-6 text-brand-yellow mr-3 mt-0.5 flex-shrink-0" data-id="element-818" />
                <span className="text-gray-700 text-lg" data-id="element-819">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}